import React from 'react';
import { Typography } from '@mui/material';

/**
 * Refund ID template
 */
export const RefundIdTemplate: React.FC<{ refundId?: string }> = ({ refundId }) => (
  <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>
    {refundId || '-'}
  </Typography>
);

export default RefundIdTemplate;
